import useEntities from 'hooks/useEntities';
import RelationsTable from 'components/RelationsTable';
import { Button, Checkbox, DatePicker, Form, Input, Modal, Select, Table, TimePicker, Tooltip, Radio } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import moment from 'moment';
import SchedulerConfigIcePatternModal from 'components/SchedulerConfig/SchedulerConfigIcePatternModal';
import SchedulerConfigIcePatternsCalendar from 'components/SchedulerConfig/SchedulerConfigIcePatternsCalendar';
import useSearchParamsMulti from 'hooks/useSearchParamsMulti';

const SchedulerConfigSimulations = ({ sourceEntityId, data, onChange, phases }) => {
    const entities = useEntities();
    const sourceEntity = entities.SchedulerConfig;
    const targetEntity = entities.SchedulerSimulation;
    
    const views = useMemo(() => [
        { value: 'SUCCEEDED', label: 'Succeeded', data: data?.filter(r => (r.errCount ?? 0) === 0) },
        { value: 'FAILED', label: 'Failed', data: data?.filter(r => (r.errCount ?? 0) > 0) },
    ], [data]);

    const { useSearchParamSingle } = useSearchParamsMulti();
    const [view, setView] = useSearchParamSingle('schedulerSimulationView', views[0].value);

    const tableData = views.find(v => v.value == view)?.data ?? [];

    const ViewSelector = () => {
        return (
            <Radio.Group
                size="small"
                value={view}
                onChange={(e) => setView(e.target.value)}
            >
                {views.map((v, idx) => (
                    <Radio.Button key={idx} value={v.value}>
                        {v.label} ({v.data?.length})
                    </Radio.Button>
                ))}
            </Radio.Group>
        );
    };

    return (
        <>
            <RelationsTable
                data={tableData}
                sourceEntity={sourceEntity}
                targetEntity={targetEntity}
                sourceEntityId={sourceEntityId}
                emptyMessage={`This ${sourceEntity.displayName} does not have any ${targetEntity.displayNamePlural}`}
                canOpen={true}
                extraButtonBarItems={<ViewSelector />}
            />
        </>
    )

}

export default SchedulerConfigSimulations
